import { createAction } from '@reduxjs/toolkit';

const addToAdded = createAction('archive/addToAdded');

export default addToAdded;
